import { render, staticRenderFns } from "./payment-record.vue?vue&type=template&id=0bc209d2&scoped=true&"
import script from "./payment-record.vue?vue&type=script&lang=js&"
export * from "./payment-record.vue?vue&type=script&lang=js&"
import style0 from "./payment-record.vue?vue&type=style&index=0&id=0bc209d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc209d2",
  null
  
)

export default component.exports